import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Logo & Company */}
          <div>
            <img
              src={companyInfo.logos.mindFlex}
              alt="Mind Flex Games"
              className="w-full max-w-[400px] h-auto md:w-[300px] md:h-[75px] sm:w-[250px] sm:h-[62px] object-contain"
              style={{ maxHeight: '100px' }}
            />
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                >
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <address className="not-italic text-slate-400 text-sm leading-relaxed">
              {companyInfo.name}<br />
              {companyInfo.address.street}<br />
              {companyInfo.address.city}, {companyInfo.address.state} {companyInfo.address.zip}
            </address>
          </div>
        </div>
      </div>

      {/* Bottom Bar - Legal Disclaimers */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          {/* Disclaimers */}
          <div className="mb-6 space-y-3">
            <p className="text-slate-500 text-xs leading-relaxed">
              <strong className="text-slate-400">US Jurisdiction:</strong> Mind Flex Games, LLC is a company registered and operating under the laws of the United States of America. All business operations are conducted in accordance with applicable federal and state regulations.
            </p>
            <p className="text-slate-500 text-xs leading-relaxed">
              <strong className="text-slate-400">Age Restriction:</strong> All participants must be of legal age in their respective jurisdictions. Age verification is required for platform access. Our services are intended for adults only and are not available to persons under the legal age requirement.
            </p>
            <p className="text-slate-500 text-xs leading-relaxed">
              <strong className="text-slate-400">Availability:</strong> Services are not available where prohibited by law. Platform availability varies by jurisdiction. Users are responsible for ensuring compliance with local laws before participating.
            </p>
          </div>

          {/* Copyright */}
          <div className="flex flex-col sm:flex-row justify-between items-center pt-4 border-t border-slate-800/50">
            <p className="text-slate-500 text-xs">
              © {currentYear} Mind Flex Games, LLC. All rights reserved.
            </p>
            <p className="text-slate-600 text-xs mt-2 sm:mt-0">
              Skill-Based Gaming | Compliance-Driven
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
